import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    getRiwayatStory: ({ commit, getters, rootGetters }, { iddevice }) => {
        let getFilter = rootGetters["filterGlobalModule/getFilter"];
        let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

        let query = {
            iddevice,
            offset: getters.storyRiwayatPage.offset,
            limit: getters.storyRiwayatPage.limit,
            order_by: getFilter.orderBy,
        };

        Object.keys(getFilterItem).forEach((key) => {
            if (getFilterItem[key].length > 0) {
                switch (key) {
                    case "statusKonfirmasi":
                        query.status = getFilterItem[key];
                        break;
                }
            }
        });

        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getRiwayatStory, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    conn.setQueryString(query);
                    commit("setStoryRiwayat", data);
                    commit("setEndStoryRiwayat", data.array[data.array.length - 1]);
                    commit("setNextStoryRiwayatPage", data.array);
                    commit("setResponse", resulter.successResult(msg));
                }
                commit("setFetching", false);
                commit("setLoadMore", false);
            })
            .catch((e) => {
                commit("setLoadMore", false);
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    setEndStoryRiwayat: ({ commit }, payload) => {
        commit("setEndStoryRiwayat", payload);
    },
    toggleShowStoryRiwayat: ({ commit }, payload) => {
        commit("toggleShowStoryRiwayat", payload);
    },
};
